module.exports = __webpack_public_path__ + "img/faq3.d53f61f0.png";